<template>
  <div>
    <div class="category-select">
      <div
        :class="[
          'category-select-input',
          !category.count && 'category-disabled',
        ]"
      >
        <input
          ref="parentCategory"
          v-model="selected"
          type="checkbox"
          @change="handleCheck"
          :id="category.id"
        />
        <label class="cursor-pointer mb-0" :for="category.id">
          {{ category.name }}
        </label>
      </div>
      <button
        :style="{
          background: 'none',
          border: 'none',
          outline: 'none',
        }"
        @click="handleShowSubcategory"
        v-if="category.subcategories?.length"
      >
        <font-awesome-icon
          icon="fa-solid fa-chevron-up"
          size="sm"
          v-if="showSubcategory"
        />
        <font-awesome-icon icon="fa-solid fa-chevron-down" size="sm" v-else />
      </button>
    </div>
    <div
      class="subcategories-select-container"
      v-if="category.subcategories?.length && showSubcategory"
    >
      <CategoryItem
        v-for="subcategory in category.subcategories"
        :checked="isDefaultChecked(subcategory.id)"
        :key="subcategory.id"
        :category="subcategory"
        @select="handleSelectSubcategory"
        @deselect="handleDeselectSubcategory"
      />
    </div>
  </div>
</template>

<script>
import CategoryItem from "./CategoryItem";
export default {
  components: { CategoryItem },
  name: "CategoryItem",
  props: {
    category: Object,
    checked: Boolean,
    checkedSubcategories: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["select", "deselect"],
  data() {
    return {
      showSubcategory: this.checked,
      selected: this.checked,
    };
  },
  methods: {
    handleShowSubcategory() {
      this.showSubcategory = !this.showSubcategory;
    },

    handleCheck() {
      if (this.selected) {
        this.$emit("select", this.category.id);
      } else {
        this.$emit("deselect", this.category.id);
      }
    },

    handleSelectSubcategory(id) {
      if (!this.$refs.parentCategory.checked) {
        this.$refs.parentCategory.checked = true;
      }

      this.$emit("select", id);
    },

    handleDeselectSubcategory(id) {
      this.$emit("deselect", id);
    },

    isDefaultChecked(id) {
      return this.checkedSubcategories?.find((catId) => catId === id)
        ? true
        : false;
    },
  },
  
  watch: {
    checked(newVal) {
      this.selected = newVal;
    },
  },
};
</script>

<style>
.category-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 5px;
}

.category-disabled {
  pointer-events: none;
  opacity: 0.4;
}

.category-select-input {
  display: flex;
  gap: 10px;
}

.subcategories-select-container {
  padding-left: 2.5rem;
}

.category-select input {
  width: auto;
}
</style>
